/*
 * Lack Depot — replace €0.00 prices on collection cards
 * with a friendlier "Preis auf Anfrage" / "Price on request".
 * Runs after DOM ready and watches for dynamically loaded cards.
 */
(function () {
  const ZERO_PATTERNS = [/^€\s*0[,.]00$/i, /^0[,.]00\s*€$/i, /^€0\.00$/i, /^0\.00\s*€$/i];
  const isDE = (document.documentElement.lang || '').toLowerCase().startsWith('de');
  const REPLACEMENT = isDE ? 'Preis auf Anfrage' : 'Price on request';

  function fix(el) {
    if (!el || el.dataset.priceFixed === '1') return;
    const txt = el.textContent.trim();
    if (ZERO_PATTERNS.some(p => p.test(txt))) {
      el.textContent = REPLACEMENT;
      el.classList.add('price-zero');
      el.dataset.priceFixed = '1';
    }
  }

  function scan() {
    const candidates = document.querySelectorAll(
      '.card-wrapper .price-item--regular, ' +
      '.card-wrapper .price__regular, ' +
      '.card-wrapper .money, ' +
      '.card-wrapper [class*="price-item"]'
    );
    candidates.forEach(fix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-scan periodically for AJAX-loaded content (filters, pagination)
  let lastCount = 0;
  setInterval(() => {
    const cards = document.querySelectorAll('.card-wrapper').length;
    if (cards !== lastCount) {
      lastCount = cards;
      scan();
    }
  }, 600);
})();
